exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * @prettier\n */\n@media screen and (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n@media (min-width: 768px) {\n}\n@media (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n@media (min-width: 768px) {\n}\n@media (max-width: 767px) {\n}\n@media (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n.linkBox___1r_OY {\n  font-size: 16px;\n  margin: 20px 0;\n}\n.modal-dialog.modal___3C-R_ {\n  max-width: 758px;\n  width: 100%;\n}\n", ""]);

// exports
exports.locals = {
	"linkBox": "linkBox___1r_OY",
	"modal": "modal___3C-R_"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/cards/components/common/SingleSample/SingleSampleModalLinkPLP/styles.module.less
// module id = 1700
// module chunks = 51